import { render } from "./RemoteMonitoringEventItemProxy.vue?vue&type=template&id=0c75b77e&ts=true"
import script from "./RemoteMonitoringEventItemProxy.vue?vue&type=script&lang=ts"
export * from "./RemoteMonitoringEventItemProxy.vue?vue&type=script&lang=ts"

import "./RemoteMonitoringEventItemProxy.vue?vue&type=style&index=0&id=0c75b77e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__